import { Injectable } from '@angular/core';

import { AOFirebaseService } from './ao-firebase.service';

@Injectable({
  providedIn: 'root'
})
export class AOFirebaseSlaveService extends AOFirebaseService {

  protected _name = 'slave';

}
